import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authClient } from './Users/defaults';

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await authClient.get('/validate-session');
        setIsAuthenticated(true);
      } catch (err) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login-signup" replace />;
};

export default PrivateRoute;
